const WA_MESSAGE = "Ciao DuoClair! Vorrei maggiori informazioni sui vostri servizi per la mia attività.";

export const DUOCLAIR_WHATSAPP = {
  display: "+39 352 245 8940",
  number: "393522458940",
  link: `https://wa.me/393522458940?text=${encodeURIComponent(WA_MESSAGE)}`,
};

export const waLink = (message) =>
  `https://wa.me/${DUOCLAIR_WHATSAPP.number}?text=${encodeURIComponent(message)}`;
